import UmooveApi from "../../../components/api/UmooveApi";
import { useContext, useEffect, useState } from "react";
import "./style.css";
import arrow from "./arrows.svg";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../../components/Common/Button";
import mainContext from "../../../context/mainContext";
import dataContext from "../../../context/dataContext";
import userRequests from "../../../components/api/userRequests";

//TODO - check if the result are ok
//TODO - turn off the camera

// TODO - end of train focus +++

function Exercise() {
  const localDataContext = useContext(dataContext);
  // UmooveApi.API_loadUmooveLibrary().then(() => {
  // }).catch((error) => { console.error(error) })
  // UmooveApi.API_startUmoove()

  const [dist, setDist] = useState(0);
  const [side, setSide] = useState(0);
  const [DailyStoppingDistance, setDailyStoppingDistance] = useState(0);
  const [StoppingDistance, setStoppingDistance] = useState(0);
  const [distArray, setDistArray] = useState([]);
  const [check, setCheck] = useState(0);
  const [pushupDirection, setPushupDirection] = useState("pull")
  const navigate = useNavigate();
  const location = useLocation();

  const RoundNumber = localStorage.RoundNumber
    ? Number(localStorage.RoundNumber)
    : 1;

  const {
    header: { setIsShowHeader },
    stream: { setStreamObj, streamObj },
    loader: { loaderFetch, setLoaderFetch },
  } = useContext(mainContext);



  useEffect(() => {
    if (location?.state?.distances[0]) {
      setDistArray([...location?.state?.distances[0]]);
      console.log("dist INSIDE ", location.state?.distances[0]);
    }
  }, []);
  useEffect(() => {
    setIsShowHeader("");

    // const toCenterlize =
    const alignmentInterval = setInterval(() => {

      setSide(prev => {
        let aligment = UmooveApi.API_getAlignment();
        return aligment.TH == 0 ? prev : aligment.align;
      });
    }, 10);

    const distInterval = setInterval(() => {
      setDist(UmooveApi.API_getDistance())
    }, 100);
    return () => {
      clearInterval(alignmentInterval);
      clearInterval(distInterval);
      setIsShowHeader(true)
      console.log("detroyed!");
    };
  }, []);

  let finalDistanceAvg = 0;
  let rounds = 4;
  function Round() {
    let avg = 0;

    if (RoundNumber === rounds) {
      let totalSum = distArray.reduce((acc, curr) => (acc += curr), 0);
      avg = totalSum / distArray.length;
      // UmooveApi.API_stopUmoove(false);
      localStorage.removeItem("RoundNumber");
    } else {
      // currDists.push(distance);
      // setDistArray([...currDists]);
    }

    localStorage.RoundNumber = Number(localStorage.RoundNumber) + 1;
    if (RoundNumber >= rounds) {
      UmooveApi.API_startUmoove(false);
      UmooveApi.API_stopUmoove(true);
      setLoaderFetch(true);
      userRequests.addNewTf(avg, localDataContext.userDetails).then((updateUserDatails) => {
        localDataContext.setUserDetails(updateUserDatails)
        navigate("/train-focus/result", { replace: true, state: { comfortDistance: avg }, });
      }).finally(() => {
        setLoaderFetch(false);
      })
    } else {
      navigate("/train-focus/start-focus", {
        replace: true,
        state: { dist: [...distArray] },
      });
    }
  }

  function changeDirect() {
    const distance = UmooveApi.API_getDistance();
    let currDists = [...distArray];
    currDists.push(distance);
    setDistArray([...currDists]);
    setPushupDirection("push")

  }



  return (
    <div className="pages-no-head">
      <div
        className="purpleDot"
        style={{ left: localStorage.getItem("posX") + "px" }}
      ></div>
      {side !== 0 && (
        <div className={side === -1 ? "back_center_Left" : "back_center_Right"}>
          {" "}
          <div className="text_box">
            Move the phone a bit to the {side === -1 ? "left" : "right"}
          </div>
          {/* TODO: in debug only??? */}
          <img
            className={side === -1 ? "flip_img_left" : "flip_img_right"}
            src={arrow}
            alt="img"
          />
        </div>
      )}
      {/* <div>{dist}</div> */}
      {side == 0 && <div className="bo btnHolder" >
        {pushupDirection == "pull" && <>
          <Button title="Pause" startFunction={changeDirect} disabled={side !== 0} moreStyle={{ height: "35vh", fontSize: "9vh" }} />
        </>}
        {pushupDirection == "push" && <>
          <div className="explain"><p>When you are back at arms length click to continue</p></div>
          <Button title="NEXT" startFunction={Round} disabled={side !== 0} />
        </>}
      </div>}
    </div>
  );
}

export default Exercise;